import { Grid } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { ConnectBox, ConnectButton, Title } from './ConnectionButton.styles';
import { ConnectionButtonProps } from './ConnectionButton.types';

export const ConnectionButton: FC<ConnectionButtonProps> = memo((props) => {
    const { title, logo: Logo, isLoading, onClick } = props;

    return (
        <ConnectButton onClick={onClick} disabled={isLoading}>
            <ConnectBox radius='small' spacing='16' borderColor='midnight50' bordered borderInside>
                <Grid gridTemplateColumns='max-content auto' alignItems='center' gap={8}>
                    <Logo width={32} height={32} />

                    <Title font='label' fontSize='medium' color='midnight100'>
                        {title}
                    </Title>
                </Grid>
            </ConnectBox>
        </ConnectButton>
    );
});

ConnectionButton.displayName = 'ConnectionButton';
